import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-carousel-calendar',
  templateUrl: './carousel-calendar.component.html',
  styleUrl: './carousel-calendar.component.scss'
})
export class CarouselCalendarComponent implements OnInit {
  @ViewChild('carouselContainer') carouselContainer: ElementRef;
  cards: any[] = [
    {
      "id": "1",
      "name": "Enero",
    },
    {
      "id": "2",
      "name": "Febrero",
    },
    {
      "id": "3",
      "name": "Marzo",
    },
    {
      "id": "4",
      "name": "Abril",
    },
    {
      "id": "5",
      "name": "Mayo",
    },
    {
      "id": "6",
      "name": "Junio",
    },
    {
      "id": "7",
      "name": "Julio",
    },
    {
      "id": "8",
      "name": "Agosto",
    },
    {
      "id": "9",
      "name": "Septiembre",
    },
    {
      "id": "10",
      "name": "Octubre",
    },
    {
      "id": "11",
      "name": "Noviembre",
    },
    {
      "id": "12",
      "name": "Diciembre",
    }
  ]

  language: string;
  lastYear: number;
  nextYear: number;
  linkVenue: string = "";
  year: number;
  month: number;

  @Input() cant: number = 5;
  isDesktop: boolean = true;
  currentIndex: number = 0;
  lockedLeft = true;
  lockedRight = false;
  componentId = 'carousel-' + Math.random().toString(36).substring(7);
  carouselTransform: string = 'translateX(0)';  // Propiedad vinculada para el desplazamiento


  constructor(public route: ActivatedRoute) {
    this.route.params.forEach((params: Params) => {
      this.language = params['language'];
      this.year = params['year'];
      this.lastYear = Number(params['year']) - 1;
      this.nextYear = Number(params['year']) + 1;
      if (params["venueCalendar"]) {
        this.linkVenue = "/" + params["venueCalendar"]
      }

      this.month = params['month'];
      this.goToPosition(this.month - 1);

    })
  }

  ngOnInit(): void {
    this.checkScreenSize();
  }

  ngAfterViewInit(): void {
    var wd = 220;
    var wm = 730;
    var ad = ((this.month - 1) * wd);
    var am = ((this.month - 1) * wm);

    $("#mes-d" + this.month).addClass("actived");
    $("#mes-m" + this.month).addClass("actived");



  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkScreenSize();
  }

  checkScreenSize() {
    this.isDesktop = window.innerWidth > 768;
    this.cant = (this.isDesktop) ? 4 : 1;
    this.goToPosition(this.month - 1);

  }

  // Mover a la izquierda
  moveLeft() {
    if (this.currentIndex > 0) {
      this.currentIndex -= 1; // Mover el índice según el valor de 'cant'
      this.updateCarouselPosition();
    }

    // Bloquear flecha izquierda si estamos en el primer conjunto
    this.lockedLeft = this.currentIndex === 0;
    this.lockedRight = false; // Desbloquear flecha derecha
  }

  // Mover a la derecha
  moveRight() {
    if (this.currentIndex + this.cant < this.cards.length) {
      this.currentIndex += 1; // Mover el índice según el valor de 'cant'
      this.updateCarouselPosition();
    }

    // Bloquear flecha derecha si ya no hay más elementos
    this.lockedRight = this.currentIndex + this.cant >= this.cards.length;
    this.lockedLeft = false; // Desbloquear flecha izquierda
  }

  // Actualizar la posición del carrusel usando transform
  updateCarouselPosition() {
    // Calcula el desplazamiento en porcentaje
    const cardWidth = 100 / this.cant;  // El ancho de cada card en porcentaje
    const offset = this.currentIndex * cardWidth;  // Desplazamiento total basado en el índice
    this.carouselTransform = `translateX(-${offset}%)`;  // Actualiza el estilo de transform
  }
  goToPosition(index: number) {
    if (index >= 0 ) {
      this.currentIndex = index;
      this.updateCarouselPosition();
    }

    // Bloquear flechas según la nueva posición
    this.lockedLeft = this.currentIndex === 0;
    this.lockedRight = this.currentIndex + this.cant >= this.cards.length;
  }
}
